module.exports = __webpack_public_path__ + "a1e29472b760b6a1f28af1b22f678480.svg";